export default __webpack_public_path__ + "static/media/logo2.715b2569.jpg";